import { GLOBAL_CONSTANTS } from 'assets/js/utils/constants.js'

const SELECTORS = {
  adlamHomePage: '.js-adlam-home-page',
  information: '.js-adlam-home-page__information',
  translate: '.js-adlam-home-page__information__translate',
  headline: '.js-adlam-home-page__information__headline',
  headlineTitle: '.js-adlam-home-page__information__headline--title',
  headlineTranslation: '.js-adlam-home-page__information__headline--title-translation',
  translationText: '.js-translation-text'
}

class AdlamHomePage {
  constructor (element) {
    this.element = element
    this.emitter = GLOBAL_CONSTANTS.UTILS.EMITTER
    this.information = this.element.querySelector(SELECTORS.information)
    this.translate = this.element.querySelector(SELECTORS.translate)
    this.headline = this.element.querySelector(SELECTORS.headline)
    this.headlineTitle = this.element.querySelector(SELECTORS.headlineTitle)
    this.headlineTranslation = this.element.querySelector(SELECTORS.headlineTranslation)
    this.translationText = this.element.querySelector(SELECTORS.translationText)
    this.query = window.matchMedia('(min-width: 768px)')
    this.observer = null

    this.init()
  }

  init() {
    this.registerEvents()

    this.translationText.innerHTML = this.translationText.dataset.adlamlabel

    if (document.documentElement.classList.contains('reduced-motion')) {
      this.element.classList.remove('-pre')
      this.element.classList.remove('-expanded')
    }
  }

  registerEvents() {
    this.emitter.on(GLOBAL_CONSTANTS.EVENTS.ELEMENT_IN_VIEWPORT, event => {
      if (event.target === this.information) {
        this.triggerBackground()
      } else if (event.target === this.element) {
        this.animateImages()
      }
    })
    this.translate.addEventListener('click', this.translateText.bind(this))
  }

  triggerBackground() {
    this.element.classList.add('-color-active')
  }

  translateText() {
    this.information.classList.toggle('-translated')

    const isTranslated = this.information.classList.contains('-translated')

    this.headlineTitle.setAttribute('aria-hidden', isTranslated ? 'false' : 'true')
    this.headlineTranslation.setAttribute('aria-hidden', isTranslated ? 'true' : 'false')

    this.translationText.innerHTML = isTranslated ? this.translationText.dataset.englishlabel : this.translationText.dataset.adlamlabel
  }

  animateImages() {
    this.element.classList.remove('-pre')
  }
}

export default {
  selector: SELECTORS.adlamHomePage,
  Source: AdlamHomePage
}
